import { IOrderPayload } from '@/app/[locale]/_types'

const checkoutReducer = (state: IOrderPayload, { type, payload }: any) => {
  switch (type) {
    case 'SET_VALUES':
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}

export default checkoutReducer
